@import "@/ui/variables.css";

.spinnerRoot {
  --color: var(--white);
  --size: 15px;

  width: var(--size);
  height: var(--size);
  position: relative;
  text-align: center;

  -webkit-animation: sk-rotate 2s infinite linear;
  animation: sk-rotate 2s infinite linear;

  &[data-size="2"] {
    --size: 40px;
  }
}

.spinnerRoot[data-variant="dark"] {
  --color: var(--gray);
}

.spinnerRoot::before,
.spinnerRoot::after {
  content: "";
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: var(--color);
  border-radius: 100%;

  animation: sk-bounce 2s infinite ease-in-out;
}

.spinnerRoot::after {
  top: auto;
  bottom: 0;
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

@-webkit-keyframes sk-rotate {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes sk-rotate {
  100% {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes sk-bounce {
  0%,
  100% {
    -webkit-transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bounce {
  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
